import { render, staticRenderFns } from "./MeasurementRoofAccessPage.vue?vue&type=template&id=18185472"
import script from "./MeasurementRoofAccessPage.vue?vue&type=script&lang=js"
export * from "./MeasurementRoofAccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports